export default __webpack_public_path__ + "static/media/suliac-room3-min.6e9af50d.jpg";